<div class="rich-editor"
  [ngClass]="{'rich-editor--error': field?.error}">
  @if (initEditor) {
    <editor
      apiKey="no-api-key"
      cloudChannel="5"
      [disabled]="noEditable"
      [id]="elementId"
      [init]="richEditor"
      [initialValue]="modelText"
      [inline]="false"
      plugins="lists advlist"
      tagName="div"
    [toolbar]="toolbar"></editor>
  }
</div>
<button
  [id]="'addLink-'+elementId"
  class="rich-editor__button-modal"
  (click)="addLink($event)">
</button>
<button
  #snippetModalButton
  [hidden]="true"
  (click)="openSnippetModal()">
</button>
<button
  #listOverlayButton
  type="button"
  [hidden]="true"
  (click)="toggleListOverlay($event)">
</button>
<p-overlayPanel
  #listOverlay
  styleClass="common-dropdown-overlay__rich-editor">
  <ng-template pTemplate="content">
    @if (listOverlayConfig.filterSearch) {
      <div class="common-search__container-tonal">
        <div class="common-search__container-input-text">
          <input
            type="search"
            class="common-search__input-text"
            [(ngModel)]="listOverlayConfig.inputFilter"
            placeholder="{{'common.search-item' | afTranslate}}"
          />
        </div>
        <div class="common-search__block-button-search">
          @if (listOverlayConfig.inputFilter) {
            <button
              class="common-button__icon-xs-noborder"
              (click)="listOverlayConfig.inputFilter = ''">
              <i class="lf-icon-close-thick common-icon__sm">
              </i>
            </button>
          }
          <div
            class="h-[22px]"
            ngClass="{{listOverlayConfig.inputFilter ? 'common-divider__vertical-main-1000' : 'common-divider__vertical-grey-400'}}">
          </div>
          <i
            class="lf-icon-search common-icon__md"
            ngClass="{{!listOverlayConfig.inputFilter ? 'common-search__icon-search-disabled' : 'common-search__icon-search-enabled'}}">
          </i>
        </div>
      </div>
    }
    <div class="common-dropdown__items-container">
      @for (listItem of listOverlayConfig.list | byWord:listOverlayConfig.inputFilter:['fieldLabel']; track $index) {
        <button
          class="common-dropdown-list__si-button"
          type="button"
          (click)="onListItemClick(listItem)">
          <span-tooltip
            class="common-dropdown-list__si-text-container"
            [text]="listItem.fieldLabel"
            [tooltipPosition]="'top'">
          </span-tooltip>
        </button>
      }
      @empty {
        <span
          class="common-empty-state__searched-text"
          [afTranslate]="'common.without-results'">
          _Sin resultados
        </span>
      }
    </div>
  </ng-template>
</p-overlayPanel>
